export const AnnounceFilterResultCount = "Showing {0} filtered items.";
export const Apply = "Apply";
export const Back = "Back";
export const BestHit = "Best hit";
export const Clear = "Clear";
export const Filter = "Filter";
export const FilterOn = "Filter on";
export const FilterSelected = "{0} filter selected";
export const FilterTitle = "Filter results";
export const Keyword = "Keyword";
export const KeywordSearchResult = "\"{0}\" keyword";
export const NoFilterResults = "No items matched the supplied filter";
export const Reset = "Reset";
export const ResetAll = "Reset all";
export const SearchKeyword = "Search keyword";
